<template>
  <div class="wrap">
    <div class="place">
      <router-link class="link" to="./">首页</router-link>
      <div class="division">/</div>
      <div class="active">对账单查询</div>
    </div>
    <div class="container">
      <el-form
        :inline="true"
        :model="formInline"
        label-width="80px"
        size="mini"
        class="demo-form-inline"
      >
        <el-form-item label="单号">
          <el-input
            v-model="formInline.order_n"
            placeholder="输入单号"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="formInline.status" placeholder="请选择订单状态">
            <el-option label="未确认" value="A"></el-option>
            <el-option label="已确认" value="O"></el-option>
            <el-option label="已完成" value="F"></el-option>
            <el-option label="全部" value=""></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间段">
          <div class="block">
            <el-date-picker
              v-model="date"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSelect">查询</el-button>
        </el-form-item>
      </el-form>
      <div class="infinite-list-wrapper" :style="contentStyleObj">
        <ul
          class="list"
          v-infinite-scroll="load"
          infinite-scroll-disabled="disabled"
        >
          <li class="list-item">
            <div class="infinite-list-item">
              <div class="order_number">序号</div>
              <div class="separate"></div>
              <div class="order_n">对账单号</div>
              <div class="separate"></div>
              <div class="order_status">帐单状态</div>
              <div class="separate"></div>
              <div class="order_date">帐单日期</div>
              <div class="separate"></div>
              <div class="operation">操作</div>
            </div>
          </li>
          <li
            v-for="(item, index) in list"
            v-bind:key="index"
            :class="index%4==0?'list-item warning-row': index%4==2?'list-item success-row':'list-item'"
            @click="clickOne(index)"
            @mouseover="mouseOver(index)"
            @mouseout="mouseOut(index)"

          >
            <div :class="(index===click_row?'infinite-list-item active-row':'infinite-list-item') + (index===mouse_row?' mouse-row':'')">
              <div class="order_number">{{ index }}</div>
              <div class="separate"></div>
              <div class="order_n">{{ item.spa_code }}</div>
              <div class="separate"></div>
              <div class="order_status">{{ item.Status }}</div>
              <div class="separate"></div>
              <div class="order_date">{{ item.spa_date }}</div>
              <div class="separate"></div>
              <div class="operation"><a @click.stop="toDetail(item.dept_id,item.spa_code)">查看</a>|<a @click.stop="toPrint(item.dept_id,item.spa_code)">打印</a></div>
            </div>
          </li>
          <li class="loads" v-if="loading">加载中...</li>
          <li class="loads" v-if="noMore">没有更多了</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // name: "order",
  props:{
    addTab:{
      type:Function
    }
  },
  data() {
    return {
      contentStyleObj: {
        height: "",
        overflow: "auto",
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      date: "",
      formInline: {
        order_n: "",
        status: "A",
      },

      count: 0,
      list: [],
      loading: false,

      page: 1,
      pageSize: 50,
      click_row: '',
      mouse_row: ''
    };
  },
  created() {
    this.getHeight();
  },
  computed: {
    noMore() {
      // console.log(this.count);
      return this.count == 0;
    },
    disabled() {
      return this.loading || this.noMore;
    },
  },
  methods: {
    async load() {
      this.loading = true;
      this.page += this.page;
      await this.getOrder();
      this.loading = false;
    },
    async getOrder() {
      let date_start = "";
      let date_end = "";
      if (this.date) {
        date_start = this.date[0].format("yyyy-MM-dd");
        date_end = this.date[1].format("yyyy-MM-dd");
      }
      let params = {
        order_n: this.formInline.order_n,
        status: this.formInline.status,
        date_start,
        date_end,
        page: this.page,
        pageSize: this.pageSize,
      };
      let res = await this.$Http.getFinance(params);
      if (res.code == 0) {
        this.list = [...this.list, ...res.data];
        this.count = res.data.length;
      } else {
        this.$message.error(res.msg);
        this.loading = false;
      }
    },
    onSelect() {
      this.page = 1;
      this.list = [];
      this.click_row = '';
      this.getOrder();
    },
    //设置窗口高度
    getHeight() {
      this.contentStyleObj.height = window.innerHeight - 120 - 150 + "px";
    },
    clickOne(e){
      this.click_row=e;
    },
    mouseOver(e){
      this.mouse_row = e;
    },
    mouseOut(e){
      e;
      this.mouse_row = '';
    },
    /**
     * 查看订单详情
     */
    toDetail(dept_id,spa_code){
      let params = {
        dept_id,
        spa_code
      }
      let param = JSON.stringify(params);
      this.addTab(dept_id+spa_code,'finance_detail',param);
      // this.$router.push({ // 核心语句
      //   name: 'finance_detail',
      //   params: params
      // })
    },
    /**
     * 打印
     */
    toPrint(dept_id,spa_code){
      let url = this.GLOBAL.basic_url + 'sr_scm/printSpa?dept_id='+dept_id+'&spa_code='+spa_code;
      window.open(url);
    }
  },
};
</script>
<style scoped>
.wrap {
  padding: 0 20px;
  width: 100%;
  height: 100%;
  background-color: #fff;
  box-sizing: border-box;
}
.place {
  height: 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.division {
  padding: 0 5px;
  color: #c0c4cc;
}
.link {
  text-decoration: none;
  color: #303133;
}
.active {
  color: #909399;
}
.container {
  margin-top: 20px;
}
.infinite-list-item {
  min-width: 680px;
  height: 25px;
  line-height: 25px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  border-bottom: 1px solid #dcdfe6;
}
.infinite-list-item div {
  text-align: center;
  height: 25px;
}
.infinite-list-item .separate {
  border-right: 1px dotted #dcdfe6;
  width: 0;
}
.infinite-list-item .order_number {
  width: 50px;
}
.infinite-list-item .order_n {
  width: 120px;
}
.infinite-list-item .to_dept {
  width: 100px;
}
.infinite-list-item .order_status {
  width: 80px;
}
.infinite-list-item .order_date {
  width: 200px;
}
.infinite-list-item .operation {
  width: 120px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
}
.list {
  margin: 10px;
  margin-bottom: 0;
  border: 1px solid #dcdfe6;
  display: inline-block;
  /* border-bottom: none; */
}
.loads {
  display: block;
  /* width:100%; */
  height: 45px;
  text-align: center;
  line-height: 45px;
  /* border: 1px solid #DCDFE6;
  border-top: none;
  margin: 0 10px; */
}
.warning-row {
  background: oldlace;
}

.success-row {
  background: #f0f9eb;
}
.active-row{
  background: cornflowerblue !important;
  color: #fff !important;
}
.mouse-row{
  background:#dcdfe6;
}
.operation a {
  cursor: pointer;
}
</style>